const processContatcsForNotification = (contactData) => {
  // Parse the JSON string to an array
  // var jsonArray = JSON.parse(jsonString);

  // Create an object to store unique combinations
  var uniqueContacts = {};

  // Filter out duplicates based on the combination of properties
  var uniqueArray = contactData.filter(function (contact) {
    var key =
      contact.name +
      contact.email +
      contact.number +
      contact.isSmsRequired +
      contact.isEmailRequired;

    if (!uniqueContacts[key]) {
      uniqueContacts[key] = true;
      return true;
    }

    return false;
  });

  // Separate emails and contact numbers
  var emails = [];
  var contactNumbers = [];
  let type = "";

  uniqueArray.forEach(function (contact) {
    if (contact.isEmailRequired && contact.email) {
      emails.push(contact.email);
    }

    if (contact.isSmsRequired && contact.number) {
      contactNumbers.push(contact.number);
    }
  });

  // Check and log the result
  if (emails.length > 0 && contactNumbers.length > 0) {
    type = "SMSANDMAIL";
  } else if (emails.length > 0) {
    type = "MAIL";
  } else if (contactNumbers.length > 0) {
    type = "SMS";
  }
  return { type, emails, contactNumbers };
};

const NotificationType = {
  Email: "email",
  Sms: "sms",
  EmailAndSms: "email-sms",
};

const EmailTemplate = {
  PasswordReset: "password-reset",
  WashAppointment: "wash-appointment",
  WelcomeMail: "welcome-mail",
  ChangePassword: "change-password",
};

function generateNotificationMessageBody(
  contactsData,
  additionalNotes,
  account,
  lead,
) {
  var notificationType = NotificationType.Email;
  switch (contactsData.type) {
    case "SMSANDMAIL":
      notificationType = NotificationType.EmailAndSms;
      break;
    case "SMS":
      notificationType = NotificationType.Sms;
      break;
    default:
      notificationType = NotificationType.Email;
      break;
  }
  return {
    emails: contactsData.emails,
    phoneNumbers: contactsData.contactNumbers,
    notificationType: notificationType,
    templateType: EmailTemplate.WashAppointment,
    templateData: {
      accountName: account,
      additonalNotes: additionalNotes,
      leadName: lead,
    },
  };
}

export { processContatcsForNotification, generateNotificationMessageBody };
